import { NormalizedDeviceHardware } from "../data/device-hardware";
export const deviceHardwareNormalizeMap = {
    argo: NormalizedDeviceHardware.Argo,
    juno: NormalizedDeviceHardware.Juno,
    meridian: NormalizedDeviceHardware.Meridian,
    pisces: NormalizedDeviceHardware.Pisces,
};
export const deviceHardwareDenormalizeMap = {
    [NormalizedDeviceHardware.Argo]: ["argo"],
    [NormalizedDeviceHardware.Juno]: ["juno"],
    [NormalizedDeviceHardware.Meridian]: ["meridian"],
    [NormalizedDeviceHardware.Pisces]: ["pisces"],
};
export function normalizeDeviceHardware(rawDeviceHardware) {
    if (rawDeviceHardware === undefined) {
        return undefined;
    }
    else {
        return deviceHardwareNormalizeMap[rawDeviceHardware] ?? undefined;
    }
}
export function denormalizeDeviceHardware(normalizedDeviceHardware) {
    if (normalizedDeviceHardware === undefined) {
        return undefined;
    }
    else {
        return deviceHardwareDenormalizeMap[normalizedDeviceHardware] ?? undefined;
    }
}
/**
 * Expands a normalized device hardware value into all of its possible raw values
 */
export function expandDeviceHardware(normalizedDeviceHardware) {
    return [...(deviceHardwareDenormalizeMap[normalizedDeviceHardware] ?? [])];
}
//# sourceMappingURL=device-hardware-utils.js.map